// report-filters.js
import React from 'react';
import { 
  Box, 
  Typography, 
  Checkbox, 
  FormControlLabel, 
  IconButton,
  makeStyles 
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';

const useStyles = makeStyles((theme) => ({
  filtersContainer: {
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2),
  },
  filterGroup: {
    marginBottom: theme.spacing(1.5),
    width: '100%',
  },
  filterGroupHeader: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    padding: theme.spacing(0.5, 0),
    width: '100%',
  },
  groupLabel: {
    fontWeight: 500,
    fontSize: '0.875rem',
    marginLeft: theme.spacing(1),
  },
  groupContent: {
    paddingLeft: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column', // Make children stack vertically
    width: '100%',
  },
  filterOption: {
    margin: 0,
    display: 'flex', // Make each option take full width
    width: '100%',
    '& .MuiFormControlLabel-label': {
      fontSize: '0.875rem',
    },
    '& .MuiCheckbox-root': {
      padding: theme.spacing(0.5),
    },
  },
  checkbox: {
    color: theme.palette.text.secondary,
    '&.Mui-checked': {
      color: theme.palette.primary.main,
    },
    padding: theme.spacing(0.5),
  },
  childFilterOptions: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginTop: theme.spacing(1),
  },
  childOption: {
    marginBottom: theme.spacing(0.5),
    marginLeft: 0, // Reset margin to align properly
  }
}));

const ReportFilters = ({ filters, checkedFilters, expanded, onFilterChange, onExpandToggle }) => {
  const classes = useStyles();

  const renderFilterGroup = (filter) => {
    const isExpanded = expanded[filter.id];
    
    return (
      <Box key={filter.id} className={classes.filterGroup}>
        <Box 
          className={classes.filterGroupHeader} 
          onClick={() => onExpandToggle(filter.id)}
        >
          <Checkbox 
            className={classes.checkbox}
            checked={!!checkedFilters[filter.id]}
            onChange={(e) => {
              e.stopPropagation();
              onFilterChange(filter);
            }}
            size="small"
          />
          <Typography className={classes.groupLabel}>
            {filter.label}
          </Typography>
          <Box flexGrow={1} />
          {filter.children && (
            <IconButton size="small" onClick={(e) => {
              e.stopPropagation();
              onExpandToggle(filter.id);
            }}>
              {isExpanded ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
            </IconButton>
          )}
        </Box>
        
        {isExpanded && filter.children && (
          <Box className={classes.groupContent}>
            <Box className={classes.childFilterOptions}>
              {filter.children.map((child) => (
                <FormControlLabel
                  key={child.id}
                  className={`${classes.filterOption} ${classes.childOption}`}
                  control={
                    <Checkbox
                      className={classes.checkbox}
                      checked={!!checkedFilters[child.id]}
                      onChange={() => onFilterChange(child)}
                      size="small"
                    />
                  }
                  label={child.label}
                />
              ))}
            </Box>
          </Box>
        )}
      </Box>
    );
  };

  return (
    <Box className={classes.filtersContainer}>
      {filters.map(renderFilterGroup)}
    </Box>
  );
};

export default ReportFilters;
